export function isNullOrWhitespace(this: string | undefined | null): boolean {
  return this === null || this === undefined || this.trim() === "";
}

export function dictReplace(this: string, dict: { [key: string]: string }): string {
  return Object.keys(dict).reduce((acc, key) => acc.replace("$" + key + "$", dict[key]), this);
}

declare global {
  interface String {
    isNullOrWhitespace: typeof isNullOrWhitespace;
    dictReplace: typeof dictReplace;
  }
}

(String.prototype as any).isNullOrWhitespace = isNullOrWhitespace;
(String.prototype as any).dictReplace = dictReplace;
